import { ISubscription } from "../../Types/WaterMeterTypes"
import { toCurrency } from "../../common/utilities/parser"
import { Table } from "react-bootstrap"

type SubscriptionProps = {
    subscriptions: ISubscription[],
}

const Subscription = (props: SubscriptionProps) => {


    return (
        <Table striped hover size="sm" responsive borderless>
            <thead className="tableHeader">
                <tr>
                    <th>Navn</th>
                    <th className="text-end pe-5">Antall</th>
                    <th className="text-end">Månedspris (inkl. mva.)</th>
                </tr>
            </thead>
            <tbody>
                {props.subscriptions.map((subscription, index) => {
                    return (
                    <tr key={index}>
                        <td>{subscription.product?.productName || subscription.productCode}</td>
                        <td className="text-end pe-5">{subscription.quantity}</td>
                        <td className="text-end">{toCurrency(subscription.totPriceGross, 2)}</td>
                    </tr>
                )})
            }
            </tbody>
        </Table>
    )
}

export default Subscription